module.exports = __webpack_public_path__ + "img/_014.0bda0c6f.png";